export enum BodyAssessmentConstants {
  SET_SELECTED_EXAM = 'BodyAssessment/SET_SELECTED_EXAM',
  SET_SHOW_EXAM_MODAL = 'BodyAssessment/SET_SHOW_EXAM_MODAL',
  BODY_SURVEY = 'BodyAssessment/BODY_SURVEY',
  BODY_PARTS = 'BodyAssessment/BODY_PARTS',
  SET_BODY_SELECTION_MODE = 'BodyAssessment/BODY_SELECTION_MODE',
  BURNS_RULE_OF_NINES = 'BodyAssessment/BURNS_RULE_OF_NINES',
  BURNS_TBSA = 'BodyAssessment/BURNS_TBSA',
  NEURO_CONDITIONS = 'BodyAssessment/NEURO_CONDITIONS',
  MENTAL_CONDITIONS = 'BodyAssessment/MENTAL_CONDITIONS',
  CARDIO_CONDITIONS = 'BodyAssessment/CARDIO_CONDITIONS',
  GENERAL_EXTREMITIES = 'BodyAssessment/GENERAL_EXTREMITIES',
  EXTERNAL_SKIN = 'BodyAssessment/EXTERNAL_SKIN',
  DRAINS_TUBES = 'BodyAssessment/DRAINS_TUBES',
  OBSTETRICS = 'BodyAssessment/OBSTETRICS',
  BODY_SURVEY_FINDING = 'BodyAssessment/SET_BODY_SURVEY_FINDING',
  RESET_BODY_ASSESSMENT_STATE = 'BodyAssessment/RESET_BODY_ASSESSMENT_STATE',
}
